import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DIALOG_DATA, Dialog, DialogRef } from '@angular/cdk/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { TimePattern } from '@libs/store';
import { TimePatternEditorComponent } from '../time-pattern-editor';

export interface TimePatternEditorModalComponentData {
  timePatterns: TimePattern[];
}

export interface TimePatternEditorModalComponentResult {
  timePatterns: TimePattern[];
}

@Component({
  selector: 'lib-time-pattern-editor-modal',
  imports: [CommonModule, TranslateModule, TimePatternEditorComponent],
  templateUrl: './time-pattern-editor-modal.component.html',
  styleUrl: './time-pattern-editor-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimePatternEditorModalComponent {
  public dialogData: TimePatternEditorModalComponentData = inject(DIALOG_DATA);
  public dialog = inject(Dialog);
  private readonly dialogRef = inject(DialogRef);

  private updatedTimePatterns: TimePattern[] = this.dialogData.timePatterns;

  public updateTimePatterns(newValue: TimePattern[]): void {
    this.updatedTimePatterns = newValue;
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }

  public saveTimePatterns(): void {
    this.dialogRef.close({
      timePatterns: this.updatedTimePatterns,
    } satisfies TimePatternEditorModalComponentResult);
  }
}
